import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, Typography } from '@mui/material';
import { logEvent } from '../utils/eventLog';
import { useAuth } from './authContext';
import { FEEDBACK_SURVEY_URL, feedbackSurveyUrl } from './surveyLink';

const FONT = '"Nunito Sans", "Helvetica", "Arial", sans-serif';
const BAR_BG = '#EFEFFA';
const INK = '#08081B';
const PRIMARY = '#2A2A8B';
const HAIRLINE = '1px solid rgba(8, 8, 27, 0.15)';

export function BetaBar() {
  const { user } = useAuth();
  return (
    <Box
      data-testid="beta-bar"
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '12px',
        minHeight: 48,
        py: '4px',
        pl: '24px',
        pr: '16px',
        bgcolor: BAR_BG,
        borderBottom: HAIRLINE,
        displayPrint: 'none',
      }}
    >
      <Box
        component="span"
        sx={{
          flexShrink: 0,
          px: '8px',
          borderRadius: '4px',
          bgcolor: PRIMARY,
          color: '#FFFFFF',
          fontFamily: FONT,
          fontSize: 16,
          lineHeight: '24px',
          fontWeight: 700,
        }}
      >
        Beta
      </Box>
      <Typography sx={{ flex: '1 1 240px', minWidth: 0, fontFamily: FONT, fontSize: 16, lineHeight: '24px', fontWeight: 500, color: INK }}>
        We&apos;re still building this. Features may change, and you may hit rough edges.
      </Typography>
      <Box
        component="a"
        href={feedbackSurveyUrl(user?.id)}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          void logEvent('feedback.link_clicked.v1', {
            source: 'beta_bar',
            destination: FEEDBACK_SURVEY_URL,
          }).catch(() => {});
        }}
        sx={{
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          height: 32,
          px: '12px',
          border: `1px solid ${PRIMARY}`,
          borderRadius: '8px',
          color: PRIMARY,
          fontFamily: FONT,
          fontSize: 16,
          lineHeight: '24px',
          fontWeight: 600,
          textDecoration: 'none',
          transition: 'background-color 0.15s ease',
          '&:hover': { bgcolor: 'rgba(42, 42, 139, 0.08)' },
          '&:focus-visible': { outline: `2px solid ${PRIMARY}`, outlineOffset: '2px' },
        }}
      >
        Send feedback
        <OpenInNewIcon aria-hidden sx={{ fontSize: 16 }} />
      </Box>
    </Box>
  );
}
